import { orderService } from '../order-service/order-service';
import monitoringSchema from '../../constants/monitoring/monitoringSchema';
import { retailerSettingsService } from '../retailer-settings/retailer-settings';
import { getReturnMethodsDisplayed } from '../../lib/consolidatedMethods';
import { returnItemsService } from '../return-items-service/return-items-service';
import { getLocations, getSortable, SORT_OPTIONS } from '../../lib/locations';
import { receiveAndLogData } from '../../actions/analytics';
import { store } from '../../store';

const monitoringServiceFunction = () => {
  const getMonitoringObject = () => {
    const {
      page: { giftOrder = false, browserFingerprint, sessionId, locale } = {},
      returnReasonsMonitoring: {
        displayedReturnReasons,
        selectedReturnReason,
        nestedDisplayedReturnReasons,
        selectedNestedReturnReason,
      } = {},
      returnMethods: { returnMethods } = {},
      returnOptions: {
        returnOptions,
        returnOptionVisibility,
        returnOptionMethods,
        selectedOptionMethodKey,
        selectedOptionId,
        isAvailableOptionsApi,
      } = {},
      storeLocator: {
        locationsById,
        postalCode,
        cachedQueries: { [selectedOptionMethodKey]: { [postalCode]: locationIds = [] } = {} } = {},
        selectedLocation = null,
        selectedLocation: {
          location_id: selectedLocationId,
          brand: selectedLocationName,
          address: selectedLocationAddress,
        } = {},
        sortedBy,
        isConsolidated,
        cachedQueries,
        consolidatedLocations,
      } = {},
    } = store.getState();
    /* eslint-disable camelcase */
    const { additional_params, order_number, product, return_override_code, skip_login, zip } =
      orderService.getOrderParams();
    /* eslint-enable */

    return {
      ...monitoringSchema,
      additional_params,
      order_number,
      product,
      return_override_code,
      skip_login,
      zip,
      session_id: `_${sessionId}`,
      browser_fingerprint: browserFingerprint,
      retailer_name: retailerSettingsService.getName(),
      locale,
      event_ts: new Date(),
      is_gift: giftOrder,
      environment: window.location.hostname,
      num_eligible_items: orderService.getEligibleItemsCount(),
      num_ineligibile_items: orderService.getIneligibleItemsCount(),
      return_methods_displayed: getReturnMethodsDisplayed({
        isAvailableOptionsApi,
        returnOptions,
        returnOptionMethods,
        returnMethods,
      }),
      return_method_selected: returnItemsService.getMethod(),
      carrier: returnItemsService.getMethodCarrier(),
      return_reasons_displayed: displayedReturnReasons,
      nested_return_reasons_displayed: nestedDisplayedReturnReasons,
      return_reason_selected_id: selectedReturnReason.id || null,
      return_reason_selected_name: selectedReturnReason.name || null,
      nested_return_reason_selected_id: selectedNestedReturnReason.id || null,
      nested_return_reason_selected_name: selectedNestedReturnReason.name || null,
      ...(returnOptionVisibility.length > 0
        ? {
            return_options_displayed: returnOptionVisibility.map((option) => option.id),
            return_options_api_type: isAvailableOptionsApi ? 'availableOptions' : 'returnmethods',
          }
        : { return_options_displayed: [], return_options_api_type: null }),
      return_option_selected: selectedOptionMethodKey,
      zip_displayed: postalCode,
      ...(Object.keys(selectedLocation).length > 0
        ? {
            store_location_selected: {
              id: selectedLocationId,
              name: selectedLocationName,
              ...selectedLocationAddress,
            },
            store_location_selected_index: selectedLocation.index,
          }
        : {
            store_location_selected: null,
            store_location_selected_index: null,
          }),
      store_locations_displayed: isConsolidated
        ? [
            ...getLocations({
              postalCode,
              cachedQueries,
              locationsById,
              isConsolidated,
              consolidatedLocations,
              selectedOptionId,
              selectedOptionMethodKey,
              sortedBy,
            }),
          ].map(({ location_id: locationId, brand, address }) => ({
            id: locationId,
            name: brand,
            ...address,
          }))
        : [...locationIds].map((id) => ({
            id: locationsById[id].location_id,
            name: locationsById[id].brand,
            ...locationsById[id].address,
          })),
      store_locations_sorted_by: sortedBy,
      ...(isConsolidated &&
      getSortable({
        locations: getLocations({
          postalCode,
          cachedQueries,
          locationsById,
          isConsolidated,
          consolidatedLocations,
          selectedOptionId,
          selectedOptionMethodKey,
          sortedBy,
        }),
        sortedBy,
      })
        ? {
            store_locations_sorts_displayed: SORT_OPTIONS,
          }
        : {}),
    };
  };

  const postData = async ({ type, value }) => {
    store.dispatch(
      receiveAndLogData({
        data: getMonitoringObject(),
        type,
        value,
      }),
    );
  };

  return {
    postData,
  };
};

export const monitoringService = monitoringServiceFunction();
